import React from 'react';

const Toggle = ({ isActive, onChange, disabled, label }) => {
  return (
    <label className={`inline-flex items-center ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}>
      <input type="checkbox" checked={isActive} onChange={onChange} disabled={disabled} className="sr-only peer" />
      <div className="relative w-10 h-5 md:w-12 md:h-6 bg-gray-300 rounded-full peer peer-checked:after:translate-x-5 md:peer-checked:after:translate-x-6 peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 md:after:h-5 md:after:w-5 after:transition-all peer-checked:bg-contrast1" />
      {label && (
        <span className="select-none ms-2 md:ms-3 text-xs md:text-sm font-medium whitespace-nowrap">{label}</span>
      )}
    </label>
  );
};

export default Toggle;
